import { catchAxiosError } from 'utilities/axios';
import axiosInstance from 'api-services/api-client';

export const getActivePlan = async (id) => {
  return catchAxiosError(
    axiosInstance
      .get(`/plan/lookup/${id}`)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      }),
  );
};

export const cancelSubscription = async (uid) => {
  return catchAxiosError(
    axiosInstance
      .get(`/subscription/cancel/${uid}`)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      }),
  );
};

export const manageSubscription = async (uid) => {
  return catchAxiosError(
    axiosInstance
      .get(`/subscription/manage/${uid}`)
      .then((response) => {
        return response.data;
      })
      .catch((err) => {
        return err;
      }),
  );
};

export const getSubscription = async (uid) => {
  return catchAxiosError(
    axiosInstance
      .get(`/subscription/active/${uid}`)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      }),
  );
};

export const getTransactions = async (userId, subscriptionId) => {
  return catchAxiosError(
    axiosInstance
      .get(`/transaction/all/${userId}/${subscriptionId}`)
      .then((response) => {
        return response;
      })
      .catch((err) => {
        return err;
      }),
  );
};
